// extracted by mini-css-extract-plugin
export default {"navigation":"navigation-menu_navigation__4xPNY"};